/**
 * @generated SignedSource<<24dd7b7bff4d83dec915cb5be4c4e6aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type waitForProductExists_checkProductExistsQuery$variables = {
  productId: string;
};
export type waitForProductExists_checkProductExistsQuery$data = {
  readonly existsProductOnDesignService: boolean;
  readonly existsProductOnInterfaceService: boolean;
};
export type waitForProductExists_checkProductExistsQuery = {
  response: waitForProductExists_checkProductExistsQuery$data;
  variables: waitForProductExists_checkProductExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v2 = [
  {
    "alias": null,
    "args": (v1/*: any*/),
    "kind": "ScalarField",
    "name": "existsProductOnDesignService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "kind": "ScalarField",
    "name": "existsProductOnInterfaceService",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "waitForProductExists_checkProductExistsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "waitForProductExists_checkProductExistsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1e50cdfa665ef97520f72b121571d64a",
    "id": null,
    "metadata": {},
    "name": "waitForProductExists_checkProductExistsQuery",
    "operationKind": "query",
    "text": "query waitForProductExists_checkProductExistsQuery(\n  $productId: String!\n) {\n  existsProductOnDesignService(productId: $productId)\n  existsProductOnInterfaceService(productId: $productId)\n}\n"
  }
};
})();

(node as any).hash = "9a19dbf24c07055b1ea465e5d5d61780";

export default node;
